import { useSelector } from 'react-redux';
import {
  selectActiveProjectIds,
  selectProjectFilterMode,
  selectProjectFilterActive,
  selectProjectFilterLoading,
} from '../redux/projectFilterSlice.js';

export const useProjectFilter = () => {
  const mode = useSelector(selectProjectFilterMode);
  const activeProjectIds = useSelector(selectActiveProjectIds);
  const loading = useSelector(selectProjectFilterLoading);
  const isFiltered = useSelector(selectProjectFilterActive);

  return { mode, activeProjectIds, loading, isFiltered };
};
